export default __webpack_public_path__ + "images/favicon.v-915a697424fb4ad8eea59724c14a12ca.png";